export default {
  projectDesc: '基于 <strong>Vue2</strong> ，使用画廊或轮播模式展示图片',
  demo: {
    carousel: '跑马灯模式（轮播）',
    galleryLight: '画廊模式明亮主题',
    galleryDark: '画廊模式暗色主题',
    galleryCustom: '画廊模式自定义展示方式'
  },
  option: {
    type: '展示模式',
    images: '图片源设置，数据格式如下',
    pause: '图片展示操作栏中的暂停按钮，用于暂停自动轮播',
    title: '图片轮播或画廊全屏展示时显示图片描述内容',
    dark: '画廊模式的暗色主题',
    caption: '画廊模式中图片是否展示图片描述'
  }
}
